import { render, staticRenderFns } from "./OutsourceJobnetAreas.vue?vue&type=template&id=e38f0c4e"
import script from "./OutsourceJobnetAreas.vue?vue&type=script&lang=js"
export * from "./OutsourceJobnetAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports